import React from 'react'
import { Table } from '../components/ui/Table'
import { time } from '../util/formatters'
import { useSelector } from 'react-redux'
import { axiosGet } from '../util/api'
import { differenceInMinutes, parseISO } from 'date-fns'
import { UpdateStatusBadge } from '../components/badge/UpdateStatusBadge'
import { UpdateReportAdTypeBadge } from '../components/badge/UpdateReportAdTypeBadge'
import { Filters } from '../config'
import { Layout } from '../components/Layout'

export const ReportUpdates = (_) => {
    const profile = useSelector((state) => state.user.profile)
    const load = (params) => {
        if (!profile) {
            return Promise.resolve()
        }

        return axiosGet('report-updates', params)
    }

    const columns = [
        { key: 'status', cell: UpdateStatusBadge },
        { key: 'date' },
        { key: 'location' },
        { key: 'report_id' },
        { key: 'type', cell: UpdateReportAdTypeBadge },
        { key: 'created_at', title: 'Started', formatter: time },
        { key: 'updated_at', title: 'Finished', formatter: time },
        {
            title: 'Run Time',
            cell: (v) => {
                const start = parseISO(v.created_at)
                const end = parseISO(v.updated_at)
                const diff = differenceInMinutes(end, start)

                if (!diff) {
                    return '-'
                }

                return `${diff} mins`
            },
        },
    ]

    const filters = [Filters.UpdateStatus, Filters.UpdateReportType]

    return (
        <Layout primary="Report Updates">
            <Table
                name={'Report Updates'}
                showHeader={false}
                load={load}
                filters={filters}
                dateSelect
                columns={columns}
            />
        </Layout>
    )
}
